<template>
  <v-col :cols="attrs.cols">
    <div class="naming">
      <div v-if="attrs.add" class="mb-4 flex-wrap">
        <v-btn v-if="attrs.controls" class="mr-2" light rounded x-small @click="hideChildren = !hideChildren">{{
          hideChildren ? 'All' : 'Compact' }}</v-btn>

        <v-btn v-if="attrs.controls" class=" ml-2 mr-2" light rounded x-small @click="editMode = !editMode">{{ editMode
          ? 'Close' : 'Edit' }}</v-btn>

        <v-btn v-if="attrs.controls && !editMode" class="ml-2 mr-2" light rounded x-small
          @click="deleteList()">Delete</v-btn>
        <v-btn v-if="editMode && attrs.controls" class="ml-2" light rounded x-small color="amber"
          @click="applyNameChange">Apply</v-btn>
      </div>

      <div class="naming__header">
        <div v-if="editMode === false" class="d-flex justify-space-between align-items-center">
          <div class="mb-4">
            <p class="text-h5 mb-2">{{ item.title }}</p>
            <p v-if="item.sentence" class="text-body lh-1 mt-0">{{ item.sentence }}</p>
            <div class="d-flex mt-2 flex-wrap" v-if="attrs.tags">
              <v-chip v-for="(tag, index) in item.categories" :key="`tag-${tag}-${index}`" small class="mr-1 mb-1">
                {{ tag }}</v-chip>
            </div>

            <div v-if="attrs.note && item.body" class="mt-4">
              <article>
                <p class="text-caption text-uppercase mb-2">Description</p>
                <div class="pre-wrap" v-html="item.body"></div>
              </article>
            </div>


          </div>
        </div>

        <div v-else>
          <ColForm :key="refItem.id" :new-item="refItem" :local="attrs.local" @update="updateList" />
        </div>
        <div v-if="!editMode && attrs.controls && attrs.add" class="d-flex justify-space-between">
          <v-btn @click="addNewItem()" :color="cardForm ? 'grey' : 'amber'" class="mb-4" light rounded small>{{ cardForm
            ? 'Close' : '+' }}</v-btn>
        </div>

        <v-card v-if="cardForm" class="mb-4" elevation="2" outlined light>
          <v-card-title>Add a new items</v-card-title>

          <v-card-text>
            <ItemForm :key="`${newItem.id}-${editKey}`" :new-item="newItem" :colors="colors" :local="attrs.local"
              :attrs="attrs" @submit="addItem" @cancel="cancel" />
          </v-card-text>
        </v-card>


        <div v-if="attrs.children">
          <div>
            <NestedDraggable :key="`nested-${item.id}`" :children="items" :attrs="attrs" :depth="0" :id="item.id"
              :local="attrs.local" :hide-children="hideChildren" :is-visible="isVisible" />

          </div>
        </div>


      </div>
    </div>
  </v-col>
</template>

<script>
// @ is an alias to /src
import NestedDraggable from '@/views/user/exercises/roll-out/NestedDraggable'
import ItemForm from '@/views/user/exercises/roll-out/ItemForm'
import ColForm from '@/views/user/exercises/roll-out/ColForm'
import { checkPopulated } from '@/utils/types'

import { itemModel, initialState, colors } from './model'

export default {
  name: 'UserOfferCol',
  components: {
    NestedDraggable,
    ItemForm,
    ColForm
  },
  data() {
    return {
      items: this.value,
      refItem: this.item,
      newItem: { ...initialState },
      editMode: false,
      hideChildren: false,
      cardForm: false,
      editKey: 0,
      colors: colors
    }
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      default: () => { }
    },
    attrs: {
      type: Object,
      deafult: () => { }
    }
  },
  watch: {
    value: {
      handler(val) {
        this.items = val
      },
      deep: true
    },
    items: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true
    },
    item: {
      handler(val) {
        // watch when a new item is passed from the parent and update our reference item
        this.refItem = val
      },
      deep: true
    }
    // refItem: {
    //   handler(val) {
    //     this.$emit("onEditList", val);
    //   },
    //   deep: true,
    // },
  },

  methods: {
    // Visibility predicate passed to NestedDraggable
    isVisible(item) {
      const f = (this.attrs && this.attrs.filters) || {};

      // Build a derived filter object WITHOUT mutating the original
      const modifiedFilter = {};
      const phases = {};
      if (this._isActive(f.priorities)) phases.col1 = f.priorities;
      if (this._isActive(f.brand)) phases.col2 = f.brand;
      if (Object.keys(phases).length) modifiedFilter.phases = phases;

      // Keep any other filters you might be using (except priorities/brand which now map to phases)
      Object.keys(f).forEach(k => {
        if (k !== 'priorities' && k !== 'brand') modifiedFilter[k] = f[k];
      });

      const active = Object.entries(modifiedFilter).filter(([, v]) => this._isActive(v));
      if (active.length === 0) return true;

      return active.every(([key, val]) => {
        if (key === 'phases') return this._matchesPhases(val, item.phases);
        return this._matches(val, item[key]);
      });
    },

    // --- helpers ---
    _isActive(val) {
      if (val == null) return false;
      if (Array.isArray(val)) return val.some(v => String(v).trim() !== '');
      if (typeof val === 'object') return Object.keys(val).length > 0;
      if (typeof val === 'string') return val.trim() !== '';
      return true;
    },
    _norm(v) {
      return v == null ? '' : String(v).trim().toLowerCase();
    },
    _toArray(v) {
      return Array.isArray(v) ? v : [v];
    },

    // Generic matcher (unchanged)
    _matches(filterVal, itemVal) {
      if (!this._isActive(filterVal)) return true;
      if (itemVal == null) return false;

      const fArr = this._toArray(filterVal).map(this._norm).filter(Boolean);
      if (fArr.length === 0) return true;

      const iArr = this._toArray(itemVal).map(this._norm);
      return fArr.some(f => iArr.includes(f));
    },

    // NEW: phases matcher
    _matchesPhases(filterVal, itemPhases) {
      // If filter inactive, pass
      if (!this._isActive(filterVal)) return true;

      // Items without phases can't match an active phases filter
      if (!Array.isArray(itemPhases) || itemPhases.length === 0) return false;

      // Accept strings or arrays for each column. Either can be omitted.
      const fCol1 = filterVal?.col1;
      const fCol2 = filterVal?.col2;

      const col1Set = Array.isArray(fCol1)
        ? fCol1.map(this._norm).filter(Boolean)
        : this._isActive(fCol1) ? [this._norm(fCol1)] : [];

      const col2Set = Array.isArray(fCol2)
        ? fCol2.map(this._norm).filter(Boolean)
        : this._isActive(fCol2) ? [this._norm(fCol2)] : [];

      // If neither col1 nor col2 is active, treat as inactive
      if (col1Set.length === 0 && col2Set.length === 0) return true;

      // A phase matches if:
      //  - col1 matches (if provided), AND
      //  - col2 matches (if provided)
      const phaseMatches = (phase) => {
        const p1 = this._norm(phase.col1);
        const p2 = this._norm(phase.col2);

        const okCol1 = col1Set.length === 0 || col1Set.includes(p1);
        const okCol2 = col2Set.length === 0 || col2Set.includes(p2);

        return okCol1 && okCol2;
      };

      // Any phase row that satisfies both conditions passes
      return itemPhases.some(phaseMatches);
    },
    closeDialog() {
      this.dialog = false
    },
    applyNameChange() {
      // this will emit the new refItem abck to the parent to ass in the updated item into this component
      this.$emit('onChangeName', {
        newTitle: this.refItem.title,
        ...this.refItem
      })
      this.editMode = false
    },
    deleteList() {
      this.$emit('onDeleteList', this.item)
    },
    addNewItem() {
      // Object.assign(this.newItem, { ...itemModel });
      this.destroyProto()
      this.editKey++
      this.$nextTick(() => {
        this.cardForm = !this.cardForm
      })
    },
    addItem(ev) {
      console.log('add item', ev)
      const item = this.constructItem({ ...itemModel }, ev)
      item.id = new Date().valueOf()
      this.items.push(item)
      this.cardForm = false
      this.$emit('onEditList', ev)
    },
    destroyProto() {
      console.log('destroy proto from structure col')
      Object.assign(this.newItem, initialState())
      this.newItem.id = new Date().valueOf()
    },
    cancel() {
      this.cardForm = false
    },
    constructItem(model, item) {
      const obj = {}
      Object.keys(model).forEach(key => {
        obj[key] = checkPopulated(item[key])
      })

      return obj
    },
    updateList(ev) {
      this.$emit('onEditList', ev)
      this.editMode = false
    }
  }
}
</script>

<style lang="scss">
.delete {
  position: absolute !important;
  right: 0;
  top: 0;
  font-size: 1rem;
}

.naming {
  color: black;
}
</style>
